import { ItemType } from '@vista-digital/ocapi-types/v1';
export const isNormalItem = (item) => item.type === ItemType.Normal;
export const isParentSalesItem = (item) => item.type === ItemType.ParentSales;
export function assertIsNormalItem(item, message) {
    assertItemType(item, message, isNormalItem);
}
export const assertItemType = (item, message, typeGuard) => {
    if (!item)
        throw new Error(`${message}. Item does not exist.`);
    if (!typeGuard(item)) {
        throw new Error(`${message}. Item type '${item.type}' is not supported.`);
    }
};
//# sourceMappingURL=item-type-utils.js.map